import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsPipesModule } from 'src/app/common/pipes/components/components-pipes.module';
import { LoadingIndicatorComponent } from 'src/app/shared/components/common/loading-indicator/loading-indicator.component';

import { CardComponent } from './card/card.component';
import { ChipComponent } from './chip/chip.component';
import { ListitemAdditionalInfoComponent } from './default-listitem/additional-info/listitem-additional-info.component';
import { ListitemBottomSubheaderComponent } from './default-listitem/bottom-subheader/listitem-bottom-subheader.component';
import { ListitemHeaderComponent } from './default-listitem/header/listitem-header.component';
import { ListitemIconComponent } from './default-listitem/icon/listitem-icon.component';
import { ListitemComponent } from './default-listitem/listitem.component';
import { ListitemStatusComponent } from './default-listitem/status/listitem-status.component';
import { ListitemTopHeaderComponent } from './default-listitem/top-header/listitem-top-header.component';
import { DetailItemContainerComponent } from './detail-item-container/detail-item-container.component';
import { DetailItemIconComponent } from './detail-item/detail-item-icon/detail-item-icon.component';
import { DetailItemComponent } from './detail-item/detail-item.component';
import { DetailTitleIconComponent } from './detail-title/detail-title-icon/detail-title-icon.component';
import { DetailTitleTherapyIconComponent } from './detail-title/detail-title-therapy-icon/detail-title-therapy-icon.component';
import { DetailTitleComponent } from './detail-title/detail-title.component';
import { FooterBarComponent } from './footer-bar/footer-bar.component';
import { InfoBoxComponent } from './info-box/info-box.component';
import { InitialIconComponent } from './initial-icon/initial-icon.component';
import { LabelComponent } from './label/label.component';
import { ListHeaderComponent } from './list-header/list-header.component';
import { ModalPageHeaderComponent } from './modal-page/modal-page-header/modal-page-header.component';
import { ModalPageComponent } from './modal-page/modal-page.component';
import { SearchFilterBarComponent } from './search-filter-bar/search-filter-bar.component';
import { SearchModalInputComponent } from './search-modal/search-modal-input/search-modal-input.component';
import { SearchModalSelectionComponent } from './search-modal/search-modal-selection/search-modal-selection.component';
import { SearchModalComponent } from './search-modal/search-modal.component';
import { SectionComponent } from './section/section.component';
import { SelectModalItemComponent } from './select-modal/select-modal-item/select-modal-item.component';
import { SelectModalComponent } from './select-modal/select-modal.component';
import { TabControlComponent } from './tab-control/tab-control.component';
import { TextChipBarComponent } from './text-chip-bar/text-chip-bar.component';
import { TileComponent } from './tile/tile.component';
import { WarningItemComponent } from './warning-item/warning-item.component';
import { EconomicValueCardComponent } from './economic-value-card/economic-value-card.component';
import { IntegratedCareArticleComponent } from '../integratedcare-article/integratedcare-article';
import { ArticlePipesModule } from '@common/pipes/article/article-pipes.module';
import { TherapyPipesModule } from '../../../common/pipes/therapy/therapy.module';
import { TherapyTreePipesModule } from '../../../common/pipes/therapy-tree/therapy-tree-pipes.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule.forChild(),
    FormsModule,
    ComponentsPipesModule,
    ArticlePipesModule,
    TherapyPipesModule,
    TherapyTreePipesModule,
  ],
  declarations: [
    FooterBarComponent,
    SearchFilterBarComponent,
    ListitemComponent,
    ListitemAdditionalInfoComponent,
    ListitemBottomSubheaderComponent,
    ListitemHeaderComponent,
    ListitemIconComponent,
    ListitemStatusComponent,
    ListitemTopHeaderComponent,
    DetailItemComponent,
    DetailItemIconComponent,
    ListHeaderComponent,
    DetailTitleIconComponent,
    DetailTitleComponent,
    InitialIconComponent,
    WarningItemComponent,
    ModalPageComponent,
    ModalPageHeaderComponent,
    SectionComponent,
    CardComponent,
    LabelComponent,
    SearchModalComponent,
    SearchModalInputComponent,
    SearchModalSelectionComponent,
    DetailTitleTherapyIconComponent,
    DetailItemContainerComponent,
    SelectModalItemComponent,
    SelectModalComponent,
    ChipComponent,
    TextChipBarComponent,
    LoadingIndicatorComponent,
    TabControlComponent,
    TileComponent,
    InfoBoxComponent,
    EconomicValueCardComponent,
    IntegratedCareArticleComponent,
  ],
  exports: [
    FooterBarComponent,
    SearchFilterBarComponent,
    ListitemComponent,
    ListitemAdditionalInfoComponent,
    ListitemBottomSubheaderComponent,
    ListitemHeaderComponent,
    ListitemIconComponent,
    ListitemStatusComponent,
    ListitemTopHeaderComponent,
    DetailItemComponent,
    DetailItemIconComponent,
    ListHeaderComponent,
    SectionComponent,
    DetailTitleIconComponent,
    DetailTitleComponent,
    InitialIconComponent,
    WarningItemComponent,
    ModalPageComponent,
    ModalPageHeaderComponent,
    CardComponent,
    LabelComponent,
    SearchModalComponent,
    SearchModalInputComponent,
    SearchModalSelectionComponent,
    DetailTitleTherapyIconComponent,
    DetailItemContainerComponent,
    SelectModalItemComponent,
    SelectModalComponent,
    ChipComponent,
    TextChipBarComponent,
    LoadingIndicatorComponent,
    TabControlComponent,
    TileComponent,
    InfoBoxComponent,
    EconomicValueCardComponent,
    IntegratedCareArticleComponent,
  ],
})
export class AlbertaCommonComponentsModule {}
